import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * FieldError — inline validation message rendered beneath a form field.
 * Renders nothing when `message` is falsy.
 *
 * @param {string} id   — should match the field's `aria-describedby`
 * @param {string} message
 * @param {string} testId
 */
export default function FieldError({ id, message, testId }) {
  if (!message) return null;
  return (
    <p
      id={id}
      role="alert"
      className="mt-1.5 flex items-start gap-1.5 text-xs text-destructive leading-snug"
      data-testid={testId}
    >
      <AlertCircle className="w-3.5 h-3.5 mt-[1px] flex-shrink-0" />
      <span>{message}</span>
    </p>
  );
}
